module.exports = __webpack_public_path__ + "static/media/meaningful-review-product2-full.d8f4a20e.svg";